import MarketingMiddleware from "../middlewares/marketing-middleware";
const slug = "/marketing";
const role = "Marketing";

const routes = [
  // momentaneo
  {
    path: slug,
    redirect: `${slug}/leads`,
    name: role
  },
  /* Leads */
  {
    path: `${slug}/leads`,
    name: `${role}LeadsView`,
    component: () => import("../views/lead/MarketingLeads"),
    meta: {
      middleware: [MarketingMiddleware],
      title: "Leads"
    }
  },
  {
    path: `${slug}/lead/list`,
    name: `${role}LeadListView`,
    component: () => import("../views/lead/MarketingLeadKanbanView"),
    redirect: `${slug}/leads`,
    meta: {
      middleware: [MarketingMiddleware],
      title: "Leads"
    }
  },
  {
    path: `${slug}/lead/kanban`,
    name: `${role}LeadKanbanView`,
    component: () => import("../views/lead/MarketingLeadKanbanView"),
    redirect: `${slug}/leads`,
    meta: {
      middleware: [MarketingMiddleware],
      title: "Leads"
    }
  },
  {
    path: `${slug}/reports/:tab?`,
    name: `${role}CampaignView`,
    component: () => import("../views/reports-campaings/TableReportKpis.vue"),
    meta: {
      middleware: [MarketingMiddleware],
      title: "Reportes"
    }
  }
];

export default routes;
